import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, role }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center bg-clean-white" data-testid="auth-loading">
        <div className="w-10 h-10 rounded-full border-2 border-stranger-orange border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  const allowedRoles = Array.isArray(role) ? role : role ? [role] : null;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/dashboard" replace />;

  return children;
};
